import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export const CustomerPicker = ({ customers, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const options = [{ id: "all", name: "Alle kunder" }, ...customers];
  const current = options.find((o) => o.id === value) || options[0];
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-72 justify-between font-normal" data-testid="stats-customer-select">
          <span className="truncate">{current.name}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start">
        <Command>
          <CommandInput placeholder="Søk etter havnekontor…" data-testid="stats-customer-search" />
          <CommandList>
            <CommandEmpty>Ingen kunder funnet.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o.id} value={`${o.name} ${o.id}`} onSelect={() => { onChange(o.id); setOpen(false); }} data-testid={`stats-customer-option-${o.id}`}>
                  <Check className={`w-4 h-4 mr-2 ${o.id === value ? "opacity-100" : "opacity-0"}`} />
                  {o.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
